export var mapCreateFolderResponse = function mapCreateFolderResponse(response) {
  var id = response.id,
    name = response.name,
    imageUrl = response.imageUrl,
    offersCount = response.offersCount;
  return {
    id: id,
    name: name,
    imageUrl: imageUrl || '',
    offersCount: offersCount
  };
};